// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tracking-script .tracking-buttons[data-v-76af45c9]{display:flex;flex-direction:column;justify-content:center;margin-top:-1rem}.tracking-script .tracking-buttons[data-v-76af45c9]>*{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
